import styled from 'styled-components'

export const GhostInput = styled.input.attrs({ type: 'file' })`
  display: none;
`
